import apiClient from './client';
import { User, PaginatedResponse } from '../types';

export interface PaginationParams {
  pageNo?: number;
  pageSize?: number;
}

export const userService = {
  // Get paginated users
  getPaginatedUsers: async (params?: PaginationParams): Promise<PaginatedResponse<User>> => {
    const response = await apiClient.get<PaginatedResponse<User>>('/users/paginated', {
      params: {
        pageNo: params?.pageNo || 1,
        pageSize: params?.pageSize || 20,
      },
    });
    return response.data;
  },

  // Get all users (non-paginated)
  getAllUsers: async (): Promise<User[]> => {
    const response = await apiClient.get<User[]>('/users');
    return response.data;
  },

  // Get users by IDs
  getUsersByIds: async (userIds: string[]): Promise<User[]> => {
    const response = await apiClient.get<User[]>('/users', {
      params: { userIds: userIds.join(',') },
    });
    return response.data;
  },

  // Get user by ID
  getUserById: async (userId: string): Promise<User> => {
    const response = await apiClient.get<User>(`/users/${userId}`);
    return response.data;
  },

  // Get user profile
  getProfile: async (): Promise<User> => {
    const response = await apiClient.get<User>('/users/profile');
    return response.data;
  },

  // Update profile
  updateProfile: async (user: Partial<User>): Promise<void> => {
    await apiClient.put('/users/profile', user);
  },

  // Block/Unblock user
  blockUser: async (userId: number): Promise<void> => {
    await apiClient.post(`/users/${userId}/block`);
  },
};
